import React from 'react';
import { Navigate } from 'react-router-dom';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';
import { useBrand } from '../context/BrandContext';
import { Globe } from 'lucide-react';

const NoBrandPage = () => {
  const { user, loading, logout } = useAuth();
  const { brands } = useBrand();

  // Nothing redirects away from this URL otherwise, so a reload would stay here after access is
  // granted (or after a transient empty brand list, e.g. a backend restart mid-migration).
  if (!loading && user && brands.length > 0) return <Navigate to="/" replace />;

  return (
    <div className="flex items-center justify-center min-h-screen bg-surface p-4">
      <div className="w-full max-w-md p-8 text-center rounded-xl border border-white/10 bg-surface-1">
        <Globe className="h-14 w-14 mx-auto mb-4 text-ink-mute" />
        <h2 className="text-xl font-bold text-ink mb-2">No brand access</h2>
        {user && (
          <p className="text-sm text-ink-dim mb-1">
            Logged in as <strong className="text-ink">{user.email}</strong>
          </p>
        )}
        <p className="text-ink-dim mb-6">
          Your account has no brands assigned. Contact an admin to get access to a brand.
        </p>
        <Button variant="outline" onClick={logout}>Logout</Button>
      </div>
    </div>
  );
};

export default NoBrandPage;
